export class User {
    constructor(pin, role, status, login, clientType, roleName, groupId) {
        this.Accounts = [];
        this.Pin = pin;
        this.RoleName = roleName;
        this.ClientType = clientType;
        this.Role = role;
        this.Status = status;
        this.Login = login;
        this.GroupId = groupId;
        this.Email = roleName;
        this.UserAdditionalInfo = null;
    }
}
